/**
 * Eine feste Farbe je Liste, aus dem Namen gerechnet.
 *
 * Ohne das sehen zehn Listen aus wie zehn gleiche Kästen. Mit dem Namen als
 * Quelle bleibt "Wocheneinkauf" immer gleich eingefärbt, auch auf dem zweiten
 * Gerät und ohne dafür eine Spalte in der Datenbank zu brauchen.
 */
const TOENE = ["tomato", "basil", "sea", "plum", "carrot", "berry", "mint", "golden"] as const;

export function listenFarbe(name: string): string {
  let summe = 0;
  for (let i = 0; i < name.length; i += 1) summe = (summe * 31 + name.charCodeAt(i)) % 100003;
  return `var(--food-${TOENE[summe % TOENE.length]})`;
}
